import React, { useContext } from "react";
import { Text } from "@chakra-ui/react";
import { SkeletonContext } from "./skeleton-context";
import { SkeletonText } from "./skeleton-text";
export function Paragraph({ children, ...props }) {
    const skeleton = useContext(SkeletonContext);
    return (React.createElement(Text, { fontSize: "md", maxWidth: "65ch", lineHeight: "tall", position: skeleton ? "relative" : undefined, color: skeleton ? "transparent" : undefined, ...props },
        children,
        skeleton && React.createElement(SkeletonText, null)));
}
